import Axios from 'axios';


export const loyaltyPromotionApi = ({authToken, deviceId, userId, merchantId, period}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/v1/loyalty/promotion',
            params: {
                memberId : userId,
                merchantId : merchantId,
                period : period,
                offset: 0,
                pageSize : 15,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const loyaltyRewardApi = ({authToken, deviceId, userId, merchantId, period}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/v1/loyalty/reward',
            params: {
                memberId : userId,
                merchantId : merchantId,
                period : period,
                offset: 0,
                pageSize : 15,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const loyaltyTotalApi = ({authToken, deviceId, userId, merchantId}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/v1/loyalty/total',
            params: {
                memberId : userId,
                merchantId : merchantId
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const marketplaceMerchantApi = ({authToken, deviceId, userId, merchantId, period}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'dashboard/marketplace/merchant',
            params: {
                memberId : userId,
                merchantId : merchantId,
                period : period,
                offset: 0,
                pageSize : 99999,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const marketplaceProductApi = ({authToken, deviceId, userId, merchantId, period}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'dashboard/marketplace/product',
            params: {
                memberId : userId,
                merchantId : merchantId,
                period : period,
                offset: 0,
                pageSize : 99999,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const marketplaceRevenueApi = ({authToken, deviceId, userId, merchantId}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'dashboard/marketplace/revenue',
            params: {
                memberId : userId,
                merchantId : merchantId
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const memberGrowthApi = ({authToken, deviceId, userId, merchantId}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/member/growth',
            params: {
                memberId : userId,
                merchantId : merchantId,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const memberSummaryApi = ({authToken, deviceId, userId, merchantId}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/v1/member/summary',
            params: {
                memberId : userId,
                merchantId : merchantId,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const pointAvaliableApi = ({authToken, deviceId, userId, merchantId}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/v1/merchant/availablepoint',
            params: {
                memberId : userId,
                merchantId : merchantId,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const pointDeductApi = ({authToken, deviceId, userId, merchantId}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/v1/merchant/deductpoint',
            params: {
                memberId : userId,
                merchantId : merchantId,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};


export const tierMemberApi = ({authToken, deviceId, userId, merchantId}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURL + 'dashboard/v1/loyalty/tier',
            params: {
                memberId : userId,
                merchantId : merchantId,
            },
            data: {},
            headers:{
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};